<template>
  <result-options-wrapper
    @click-close="$emit('click-close')"
    @click-edit-quote="$emit('click-edit-quote')"
    @click-details="$emit('click-details', $event)"
  >
    <template
      #filters
    >
      <!-- FILTERS -->
      <v-expansion-panels
        v-model="panelsShown"
        multiple
        accordion
        flat
      >
        <!-- PAYMENT TYPE -->
        <v-expansion-panel>
          <v-expansion-panel-header><strong>Payment Type</strong></v-expansion-panel-header>
          <v-expansion-panel-content v-scroll-to-viewport>
            <div class="flex flex-col">
              <div class="mb-2">
                <v-btn
                  color="primary"
                  :outlined="!selectedFilters.isViewMonthly"
                  block
                  rounded
                  class="body-2"
                  @click="handleClickPaymentType(true)"
                >
                  <v-icon
                    :size="20"
                    class="mr-1"
                  >
                    {{ selectedFilters.isViewMonthly ? '$radioOn' : '$radioOff' }}
                  </v-icon>
                  <span>Monthly</span>
                </v-btn>
              </div>
              <div>
                <v-btn
                  color="primary"
                  :outlined="selectedFilters.isViewMonthly"
                  block
                  rounded
                  class="body-2"
                  @click="handleClickPaymentType(false)"
                >
                  <v-icon
                    :size="20"
                    class="mr-1"
                  >
                    {{ !selectedFilters.isViewMonthly ? '$radioOn' : '$radioOff' }}
                  </v-icon>
                  <span>Annually</span>
                </v-btn>
              </div>
            </div>
          </v-expansion-panel-content>
          <div
            v-show="!panelsShown.includes(0)"
            class="v-expansion-panel-content__wrap"
          >
            <p class="caption mb-0">
              {{ selectedFilters.isViewMonthly ? 'Monthly' : 'Annually' }}
            </p>
          </div>
          <v-divider />
        </v-expansion-panel>

        <!-- COVER TYPES -->
        <v-expansion-panel>
          <v-expansion-panel-header><strong>Cover Type</strong></v-expansion-panel-header>
          <v-expansion-panel-content v-scroll-to-viewport>
            <a
              href="#"
              class="caption"
              @click.prevent="showCoverTypesDetails"
            >
              What's the difference in cover types?
            </a>
            <radio
              v-model="coverTypes"
              class="mt-4"
              name="radio-ui-component"
              :items="options.coverTypeOptions"
              column
              wide
            />
          </v-expansion-panel-content>
          <div
            v-show="!panelsShown.includes(1)"
            class="v-expansion-panel-content__wrap"
          >
            <p class="caption mb-0">
              {{ coverTypes }}
            </p>
          </div>
          <v-divider />
        </v-expansion-panel>

        <!-- VET FEES -->
        <v-expansion-panel>
          <v-expansion-panel-header><strong>Vet fees {{ coverTypeRelatedLabel && `(${coverTypeRelatedLabel})` }}</strong></v-expansion-panel-header>
          <v-expansion-panel-content v-scroll-to-viewport>
            <a
              href="#"
              class="caption"
              @click.prevent="showVetFeesDetails"
            >
              Vet fees explained
            </a>
            <v-select
              v-model="vetFees"
              :items="options.vetFeesOptions"
              outlined
              dense
              hide-details
              attach
              class="mt-2"
            />
          </v-expansion-panel-content>
          <div
            v-show="!panelsShown.includes(2)"
            class="v-expansion-panel-content__wrap"
          >
            <p class="caption">
              {{ vetFeesLabel }}
            </p>
          </div>
        </v-expansion-panel>
      </v-expansion-panels>
    </template>
  </result-options-wrapper>
</template>

<script>
import ResultOptionsWrapper from '@/components/results/ResultOptionsWrapper';
import { inject } from '@vue/composition-api';

export default {
  name: 'results-options',
  components: { ResultOptionsWrapper },
  inject: ['constants'],
  props: {
    formData: {
      type: Object,
      required: false,
      default: () => {},
    },
    options: {
      type: Object,
      required: true,
    },
    selectedFilters: {
      type: Object,
      required: true,
    },
    coverTypeRelatedLabel: {
      type: String,
      default: '',
    },
    func: {
      type: Function,
      default: () => {},
    },
  },
  data: () => ({
    panelsShown: [0, 1, 2],
  }),
  created () {
    this.setDefaultFilterValues();
  },
  computed: {
    coverTypes: {
      get () {
        return this.selectedFilters.coverTypes;
      },
      set (value) {
        return this.$emit('change-filter', { filter: 'coverTypes', value });
      },
    },
    vetFees: {
      get () {
        return this.selectedFilters.vetFees;
      },
      set (value) {
        return this.$emit('change-filter', { filter: 'vetFees', value });
      },
    },
    vetFeesLabel () {
      return this.options.vetFeesOptions.find(option => option.value === this.vetFees)?.text;
    },
  },
  methods: {
    setDefaultFilterValues () {
      if (!this.coverTypes) {
        this.coverTypes = this.formData.proposer.petTypeOfCover === 1 ? 'Accidents only' : this.constants.COVER_TYPE_OPTIONS.find(item => item.formRelatedValue === this.formData.proposer.coverDuration).value;
      }
      if (!this.vetFees) {
        this.vetFees = this.formData.proposer.coverAmount;
      }
    },
    handleClickPaymentType (value) {
      this.internalTrackerResultsPage('paymentType', value ? 'Monthly' : 'Annually');
      return this.$emit('change-filter', { filter: 'isViewMonthly', value });
    },
    showCoverTypesDetails () {
      this.$emit('click-details', ['details-description', 'coverTypes']);
    },
    showVetFeesDetails () {
      this.$emit('click-details', ['details-description', 'vetFees']);
    },
  },
  setup () {
    const internalTrackers = inject('internalTrackers');

    return { ...internalTrackers };
  },
};
</script>

<style scoped lang="scss" src='@/assets/scss/results/results-options.scss'></style>
